// Api.js
import axios from 'axios';
import ReactSecureStorage from 'react-secure-storage';

// STG
export const devURL = 'https://dev-backend.rokithc.com/';
export const stgURL = 'https://stg-backend.rokithc.com/';
export const prdURL = stgURL;
export const localURL = 'http://10.10.21.53:8080/';
// Server 변경 URL
const baseURL = stgURL;

const Api = axios.create({
  baseURL: baseURL,
  headers: {},
});

const noInterceptorApi = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 인터셉터 설정
Api.interceptors.request.use(
  (config) => {
    if (config.authRequired) {
      const token = ReactSecureStorage.getItem('accessToken');
      const uid = ReactSecureStorage.getItem('uid');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
        config.headers['uid'] = uid;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

let flag = false;
Api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401) {
      // Refresh token is expired
      if (error.response.data.statusCode === 232) {
        if (!flag) {
            clearLocalStorageAndLogout('sessionExpired');
            alert('Your session has expired. Please log in again.');
        }
        return Promise.reject(error);
      }
      // Access token is invalid
      else if (error.response.data.statusCode === 231) {
        const reIssueResult = await ReIssueToken();
        if (reIssueResult) {
          originalRequest.headers[
            'Authorization'
          ] = `Bearer ${ReactSecureStorage.getItem('accessToken')}`;
          return axios(originalRequest);
        } else {
          // const reIssueRetryResult = await ReIssueToken();
          // if (reIssueRetryResult) {
          //   originalRequest.headers[
          //     'Authorization'
          //   ] = `Bearer ${ReactSecureStorage.getItem('accessToken')}`;
          //   return axios(originalRequest);
          // } else {
            
            if (!flag) {
              clearLocalStorageAndLogout('sessionExpired');
              alert('Your session has expired. Please log in again.');
              //window.location.href = '/';
            }
            return Promise.reject(error);
        //   }
        }
      } else {
        if (!flag) {
          clearLocalStorageAndLogout(error.response.data.message);
          alert('Your session has expired. Please log in again.');
        }
        return Promise.reject(error);
      }
    } else if (error.response && error.response.status === 403) {
      if (!flag) {
        clearLocalStorageAndLogout('403 Forbidden.');
        alert('403 Forbidden.');
        window.location.href = '/login';
        //clearLocalStorageAndLogout('403 Forbidden');
      }
      return Promise.reject(error);
    }
    else {
      if (error.response && error.response.status !== 404) {
        if (!flag) {
          clearLocalStorageAndLogout('403 Forbidden');
          alert('Server Error. Please contact the RokitHealthCare Developer.');
        }
        return error.response.data;
      }
    }
    //return Promise.reject(error);
  },
);

const ReIssueToken = async () => {
  try {
    const response = await noInterceptorApi.post(
      `/admin/member/re-issue-token`,
      {
        accessToken: `${ReactSecureStorage.getItem('accessToken')}`,
        refreshToken: `${ReactSecureStorage.getItem('refreshToken')}`,
        email: ReactSecureStorage.getItem('email'),
      },
      {
        headers: {
          Authorization: `Bearer ${ReactSecureStorage.getItem('refreshToken')}`,
          uid: ReactSecureStorage.getItem('uid'),
        },
      },
    );
    if (response.status === 200) {
      ReactSecureStorage.setItem(
        'accessToken',
        response.data.data.tokenInfo.accessToken,
      );
      ReactSecureStorage.setItem(
        'refreshToken',
        response.data.data.tokenInfo.refreshToken,
      );
      // ReactSecureStorage.setItem('uid', response.data.data.member.id);

      return true;
    }
  } catch (e) {
    window.location.href = '/login';
    return false;
  }
};

export const getApi = async (url, params) => {
  try {
    const response = await Api.get(url, {
      params: params,
      authRequired: true,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (e) {
    return e;
  }
};

export const postApi = async (url, data) => {
  try {
    const response = await Api.post(url, data, {
      authRequired: true,
      headers: {},
    });
    return response.data;
  } catch (e) {
    return e;
  }
};

export const openPostApi = async (url, data) => {
  try {
    const response = await Api.post(url, data, {
      authRequired: false,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (e) {
    return e;
  }
};

export const putApi = async (url, data) => {
  try {
    const response = await Api.put(url, data, {
      authRequired: true,
      headers: {},
    });
    return response.data;
  } catch (e) {
    return e;
  }
};

export const deleteApi = async (url) => {
  try {
    const response = await Api.delete(url, {
      authRequired: true,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (e) {
    return e;
  }
};

// 메시지 상수 정의
const SESSION_EXPIRED_MESSAGE = 'Your session has expired. Please log in again.';

// 로그아웃
export const clearLocalStorageAndLogout = (msg) => {
    // localStorage.removeItem('accessToken');
    // localStorage.removeItem('refreshToken');
    // localStorage.removeItem('@secure.n.uid');
    // localStorage.removeItem('@secure.b.authenticated');
    // localStorage.removeItem('@secure.j.memberType');
    // localStorage.removeItem('@secure.s.org');
    // localStorage.removeItem('@secure.s.code');
    // ReactSecureStorage.removeItem('accessToken');
    // ReactSecureStorage.removeItem('refreshToken');
    // ReactSecureStorage.removeItem('uid');
    // ReactSecureStorage.removeItem('role');
    // ReactSecureStorage.removeItem('authenticated');
    // ReactSecureStorage.removeItem('memberType');
    // ReactSecureStorage.removeItem('org');
    // ReactSecureStorage.removeItem('code');
    // ReactSecureStorage.removeItem('redirect');
    ReactSecureStorage.clear();
  
  if (ReactSecureStorage.getItem('redirect') === 'undefined' || 
      ReactSecureStorage.getItem('redirect') === null || ReactSecureStorage.getItem('redirect') === 'null') {
    window.location.href = '/login';
  } else {
    window.location.href = `/login?redirect=${encodeURIComponent(ReactSecureStorage.getItem('redirect'))}`;
  }
  // )
};

export default Api;
